import Vue from 'vue';
import axios from 'axios';

export const submissionState = Vue.observable({
    auth: {
        loggedIn: false,
        ni: null,
        dob: null,
    },
    termsAgreed: false,
    form: {
        submissionId: '',
    },
});

export const submissionGetter = {
    auth: () => submissionState.auth,
    modal: () => submissionState.modal,
};

export const updateSubmissionState = {
    setupAccess (access, axiosHeadersObj) {
        submissionState.auth.loggedIn = access;
        submissionState.termsAgreed = access;
        submissionState.auth.ni = axiosHeadersObj.NINumber;
        submissionState.auth.dob = axiosHeadersObj.DateOfBirth;
        axios.defaults.headers.common = axiosHeadersObj;
    },
    logout () {
        submissionState.auth.loggedIn = false;
        submissionState.termsAgreed = false;
        submissionState.auth.ni = '';
        submissionState.auth.dob = '';
        axios.defaults.headers.common = {};
        // submissionState.form.submissionId = '';
    },
    updateSubmissionId (submissionId) {
        submissionState.form.submissionId = submissionId;
    },
};
